var _a;
import Automated from "./interactiveNodes/Automated";
import CollectFormData from "./interactiveNodes/CollectFormData";
import CollectTextReply from "./interactiveNodes/CollectTextReply";
import End from "./interactiveNodes/End";
import MultiChoice from "./interactiveNodes/MultiChoice";
import Start from "./interactiveNodes/Start";
export var InteractiveNodeTypes;
(function (InteractiveNodeTypes) {
    InteractiveNodeTypes["START"] = "START";
    InteractiveNodeTypes["END"] = "END";
    InteractiveNodeTypes["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    InteractiveNodeTypes["AUTOMATED_ANSWER"] = "AUTOMATED_ANSWER";
    InteractiveNodeTypes["COLLECT_TEXT_REPLY"] = "COLLECT_TEXT_REPLY";
    InteractiveNodeTypes["COLLECT_FILE_UPLOAD"] = "COLLECT_FILE_UPLOAD";
    InteractiveNodeTypes["COLLECT_FORM_DATA"] = "COLLECT_FORM_DATA";
    InteractiveNodeTypes["CUSTOMER_IDENTIFICATION"] = "CUSTOMER_IDENTIFICATION";
    InteractiveNodeTypes["ORDER_SELECTION"] = "ORDER_SELECTION";
    InteractiveNodeTypes["ITEM_SELECTION"] = "ITEM_SELECTION";
})(InteractiveNodeTypes || (InteractiveNodeTypes = {}));
export var InteractiveFlowNodes = (_a = {},
    _a[InteractiveNodeTypes[InteractiveNodeTypes.START]] = Start,
    _a[InteractiveNodeTypes[InteractiveNodeTypes.MULTIPLE_CHOICE]] = MultiChoice,
    _a[InteractiveNodeTypes[InteractiveNodeTypes.AUTOMATED_ANSWER]] = Automated,
    _a[InteractiveNodeTypes[InteractiveNodeTypes.END]] = End,
    _a[InteractiveNodeTypes[InteractiveNodeTypes.COLLECT_FORM_DATA]] = CollectFormData,
    _a[InteractiveNodeTypes[InteractiveNodeTypes.COLLECT_TEXT_REPLY]] = CollectTextReply,
    _a);
